if (!customElements.get('path-collapsible-text')) {
  customElements.define(
    'path-collapsible-text',
    class PathCollapsibleText extends HTMLElement {
      constructor() {
        super();
        this.onToggle = this.onToggle.bind(this);
        this.onResize = this.onResize.bind(this);
      }

      connectedCallback() {
        this.content = this.querySelector('[data-collapsible-content]');
        this.toggle = this.querySelector('[data-collapsible-toggle]');

        if (!this.content || !this.toggle) return;

        this.toggle.addEventListener('click', this.onToggle);
        this.syncToggleVisibility();
        window.addEventListener('resize', this.onResize);
      }

      disconnectedCallback() {
        this.toggle?.removeEventListener('click', this.onToggle);
        window.removeEventListener('resize', this.onResize);
      }

      get expanded() {
        return this.hasAttribute('open');
      }

      setExpanded(expanded) {
        this.toggleAttribute('open', expanded);
        this.toggle.setAttribute('aria-expanded', String(expanded));
        this.toggle.textContent = expanded ? this.toggle.dataset.labelLess : this.toggle.dataset.labelMore;
      }

      onToggle() {
        this.setExpanded(!this.expanded);
      }

      syncToggleVisibility() {
        if (!this.expanded) {
          this.toggle.hidden = this.content.scrollHeight <= this.content.clientHeight + 1;
        }
      }

      onResize() {
        if (this.expanded) this.setExpanded(false);
        this.syncToggleVisibility();
      }
    }
  );
}
